/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Tab Styles",
  "description": "Change the appearance of the editor tabs to look like other mods.",
  "tags": ["editor", "MistWarp", "Theme"],
  "credits": [
    {
        "name": "Mistium",
        "url": "https://mistium.com"
    }
  ],
  "dynamicDisable": true,
  "userstyles": [
    {
      "url": "turbowarp.css",
      "if": {
        "settings": {
          "tab_style": "turbowarp"
        }
      }
    },
    {
      "url": "scratchbox.css",
      "if": {
        "settings": {
          "tab_style": "scratchbox"
        }
      }
    },
    {
      "url": "icon-only.css",
      "if": {
        "settings": {
          "looks": "icon-only"
        }
      }
    },
    {
      "url": "text-only.css",
      "if": {
        "settings": {
          "looks": "text-only"
        }
      }
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Tab style",
      "id": "tab_style",
      "type": "select",
      "potentialValues": [
        {
            "name": "MistWarp",
            "id": "mistwarp"
        },
        {
            "name": "TurboWarp",
            "id": "turbowarp"
        },
        {
            "name": "ScratchBox",
            "id": "scratchbox"
        }
      ],
      "default": "MistWarp"
    },
    {
      "dynamic": true,
      "name": "Looks",
      "id": "looks",
      "type": "select",
      "potentialValues": [
        {
            "name": "Default",
            "id": "default"
        },
        {
            "name": "Icon Only",
            "id": "icon-only"
        },
        {
            "name": "Text Only",
            "id": "text-only"
        }
      ],
      "default": "Default"
    }
  ],
  "enabledByDefault": false
};
export default manifest;
